import { render, staticRenderFns } from "./companyActive.vue?vue&type=template&id=31c06268&scoped=true&"
import script from "./companyActive.vue?vue&type=script&lang=js&"
export * from "./companyActive.vue?vue&type=script&lang=js&"
import style0 from "./companyActive.vue?vue&type=style&index=0&id=31c06268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c06268",
  null
  
)

export default component.exports